import mitt from 'mitt'

const ModalBus = new mitt()

ModalBus.on('open', () => {
  document.body.style.overflow = 'hidden'
})

ModalBus.on('close', () => {
  document.body.style.overflow = 'auto'
})

window.openModal = (component, data) => ModalBus.emit('open', { component, data })

export default ModalBus
